import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async copyUrl(event: Event) {
    const btn = event.currentTarget as HTMLButtonElement
    const url = btn.dataset.url ?? ""
    try {
      await navigator.clipboard.writeText(url)
    } catch {
      const ta = document.createElement("textarea")
      ta.value = url
      document.body.appendChild(ta)
      ta.select()
      document.execCommand("copy")
      ta.remove()
    }
    this.flashCopied(btn)
  }

  async copyQr(event: Event) {
    const btn = event.currentTarget as HTMLButtonElement
    const panel = btn.closest("[data-elections--voting-links-modal-panel]")
    const img = panel?.querySelector("img") as HTMLImageElement | null
    if (!img) return
    try {
      const response = await fetch(img.src)
      const blob = await response.blob()
      await navigator.clipboard.write([new ClipboardItem({ [blob.type]: Promise.resolve(blob) })])
      this.flashCopied(btn)
    } catch (e) {
      console.error("QR copy failed", e)
    }
  }

  private flashCopied(btn: HTMLButtonElement) {
    const orig = btn.textContent ?? ""
    btn.textContent = "Copied!"
    setTimeout(() => { btn.textContent = orig }, 1000)
  }
}
